/**
 * Supporter Wall — seed messages.
 *
 * The wall reads these on first render so the moment isn't empty for donors
 * arriving at a fresh campaign. New user-submitted messages are appended in
 * memory only (session-scoped) — a real backend will persist them.
 *
 * TODO(backend): replace with GET /api/campaigns/:id/wall
 */

const now = Date.now();
const daysAgo = (n) => new Date(now - n * 86400000).toISOString();

// Palette colors cycle across the wall for visual variety — matches the
// site's dot vocabulary (DoodleDivider, etc.).
const PALETTE = ["tangerine", "cobalt", "grass", "blossom", "yellow"];
export const dotFor = (index) => PALETTE[index % PALETTE.length];

// Two-tier seed: universal messages shown on any campaign (idx = 0..2),
// plus a per-campaign extension slot for future personalization.
const UNIVERSAL_SEEDS = [
  {
    id: "seed-w-01",
    authorName: "The Bell Family",
    message: "We're so proud of you. Keep going — this is only the beginning.",
    postedAt: daysAgo(2),
  },
  {
    id: "seed-w-02",
    authorName: "K. Sparks",
    message: "Rooting for you. The world needs more of what you're building.",
    postedAt: daysAgo(4),
  },
  {
    id: "seed-w-03",
    authorName: "Anonymous Donor",
    message: "Your story reminded me of my own first year. You've got this.",
    postedAt: daysAgo(6),
  },
];

export const getSeededMessages = () =>
  UNIVERSAL_SEEDS.map((m, i) => ({ ...m, color: dotFor(i) }));
